const DummyAd = () => (
  <div className="ad">
    <div className="placeholder-ad"></div>
  </div>
)
export default DummyAd
